import { jsx } from '@emotion/react';
import _ from 'lodash';
import { Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';

import { ContractorNameReduxConnector } from './CustomizeConnectors';
import { OrderedMenuItems } from './steps_order.jsx';
import css from './styles_header_footer';
import {
  If,
  Step,
  NextButton,
  MobilePrevButton,
  MobileNextButton,
} from './utilities';
import { store } from '../Store';
import { PrefixWithLocale } from '../Utilities';
import { connectLocation } from '../location/LocationConnectors';

const AppLogo = ContractorNameReduxConnector(
  connectLocation(({ t, contractorName }) => (
    <div css={css.appLogoContainer}>
      <Link
        to="/"
        className="appLogo"
        data-track="nav-click"
        data-track-top-level=""
      >
        <img
          src="https://imagecdn.owenscorning.com/ocimages/image/upload/q_auto,w_50/meganav/oc-logo.svg"
          alt="Owens Corning Logo"
        />
        <h1 id="summary-pdf-logo-text">
          {t('build_your_roof.build_your_roof_logo')}
        </h1>
      </Link>

      <If condition={contractorName}>
        <h6 css={css.withContractor}>
          {t('build_your_roof.with', { contractor: contractorName })}
        </h6>
      </If>
    </div>
  ))
);
AppLogo.displayName = 'AppLogo';

export const Header = connectLocation(
  ({
    t,
    menu,
    history,
    price,
    openLocationModal,
    zip,
    shingle = {},
    hideSteps = false,
  }) => (
    <>
      <section css={css.menu_container}>
        <AppLogo />

        <If condition={menu}>
          <ul className="summaryHeadings" css={css.menu_info_bar}>
            <li>
              <div id="summary-pdf-wind-header" className="heading">
                {t('build_your_roof.wind_resistance')}
              </div>
              <div id="summary-pdf-wind-result" className="result">
                <a
                  href="/roofing/warranty"
                  target="_blank"
                  data-track="learn-more"
                  data-track-destination="Warranty"
                  data-track-element-location="hero text link"
                >
                  {shingle.wind_resistance || '--'}
                </a>
                {shingle.wind_resistance && '*'}
              </div>
            </li>
            <li id="summary-pdf-shingle-warranty">
              <div id="summary-pdf-warranty-header" className="heading">
                {t('build_your_roof.shingle_warranty')}
              </div>
              <div id="summary-pdf-warranty-result" className="result">
                <a
                  href="/roofing/warranty"
                  target="_blank"
                  data-track="learn-more"
                  data-track-destination="Warranty"
                  data-track-element-location="hero text link"
                >
                  {shingle.warranty || '--'}
                </a>
                {shingle.warranty && '**'}
              </div>
            </li>
            <If condition={!store.getState().byrConfig.slug}>
              <li className="location">
                <div className="heading">{t('build_your_roof.location')}</div>
                <span
                  className="zipChange"
                  onClick={openLocationModal}
                  data-track="change-zip-open"
                >
                  <div className="result">{zip || '--'}</div>
                  <div className="change">
                    <i className="fa fa-angle-down" aria-hidden="true" />
                  </div>
                </span>
              </li>
            </If>
          </ul>
        </If>
      </section>

      <If condition={menu && !hideSteps}>
        <section css={css.menu_navigation_container}>
          <div className="stepContainer">
            <MobilePrevButton />
            <OrderedMenuItems stylesheets={css} />
            <MobileNextButton />
          </div>
        </section>
      </If>
    </>
  )
);
Header.displayName = 'Header';
export const Disclaimers = withRouter(
  connectLocation(({ t, locale, location }) => (
    <div css={css.disclaimers}>
      <p id="summary-pdf-disclaimer-1">
        {'* '}
        <a
          href={PrefixWithLocale('/roofing/warranty', locale.code)}
          target="_blank"
          data-track="learn-more"
          data-track-destination="warranty"
          data-track-element-location="main section text link"
          rel="noreferrer"
        >
          {t('build_your_roof.disclaimer_1.see_actual_warranty_text')}
        </a>
        {t('build_your_roof.disclaimer_1.following_text')}
      </p>
      <p id="summary-pdf-disclaimer-2">{t('build_your_roof.disclaimer_2')}</p>
      <p>{t('build_your_roof.disclaimer_3')}</p>
      <p>{t('build_your_roof.disclaimer_4')}</p>
      {location.pathname == '/en-us/roofing/build-your-roof/ventilation' && (
        <p>{t('build_your_roof.ventilation_disclaimer')}</p>
      )}
      {location.pathname == '/en-us/roofing/build-your-roof/underlayment' && (
        <p>{t('build_your_roof.underlayment_disclaimer')}</p>
      )}
    </div>
  ))
);
Disclaimers.displayName = 'Disclaimers';
